import LeagueLeaderboardMetaModel from "../Meta/LeagueLeaderboardMetaModel";
import LoyaltyMeta from "../Meta/LoyaltyMeta";
import TemplateBreakdownModel from "../Template/TemplateBreakdownModel";
import TemplateBreakdownPointsModel from "../Template/TemplateBreakdownPointsModel";
import LeaderboardLeagueResponse from "./LeaderboardLeagueResponse";
import LeaderboardModel from "./LeaderboardModel";
import LeaderboardResponseModel from "./LeaderboardResponseModel";

export default class LeaderboardRemapper {

    public remapResponse = (response: any): LeaderboardResponseModel => {
        response.meta = this.remapMeta(response.meta);
        response.data = this.remapData(response.data);

        return response;
    };

    public remapLeagueLeaderboardResponse = (response: any): LeaderboardLeagueResponse => {
        response.meta = this.remapLeagueLeaderboardMeta(response.meta);
        response.data = this.remapData(response.data);

        return response;
    };

    public remapTemplateBreakdown = (response: any): TemplateBreakdownModel => {
        response.meta = this.remapMeta(response.meta);
        response.data = response.data.map((d) => this.remapTemplatePoints(d));

        return response;
    };

    private remapMeta = (metaResponse: any) => {
        let metaModel = new LoyaltyMeta();

        metaModel.rankType = metaResponse.rank_type;
        metaModel.fromDate = metaResponse.from_date;
        metaModel.toDate = metaResponse.to_date;
        metaModel.pagination.currentPage = metaResponse.pagination.current_page;
        metaModel.pagination.itemsPerPage = metaResponse.pagination.items_per_page;
        metaModel.pagination.totalItems = metaResponse.pagination.total_items;
        metaModel.pagination.numberOfPages = metaResponse.pagination.number_of_pages;

        return metaModel;
    };

    private remapLeagueLeaderboardMeta = (metaResponse: any) => {
        let metaModel = new LeagueLeaderboardMetaModel();

        metaModel.templateId = metaResponse.template_id;
        metaModel.privateLeagueId = metaResponse.private_league_id;
        metaModel.fromDate = metaResponse.from_date;
        metaModel.toDate = metaResponse.to_date;
        metaModel.pagination.currentPage = metaResponse.pagination.current_page;
        metaModel.pagination.itemsPerPage = metaResponse.pagination.items_per_page;
        metaModel.pagination.totalItems = metaResponse.pagination.total_items;
        metaModel.pagination.numberOfPages = metaResponse.pagination.number_of_pages;

        return metaModel;
    };

    private remapData = (dataResponse: any[]) => {
        let leaderboardTemplate: LeaderboardModel[] = [];

        dataResponse.forEach((leaderboard: any) => {
            let dataModel = new LeaderboardModel();

            dataModel.position = leaderboard.position;
            dataModel.profileId = leaderboard.profile_id;
            dataModel.points = leaderboard.points;
            dataModel.predictionsMade = leaderboard.predictions_made;

            leaderboardTemplate.push(dataModel);
        });

        return leaderboardTemplate;
    };

    private remapTemplatePoints = (data: any) => {
        const model = new TemplateBreakdownPointsModel();

        model.groupId = data.group_id;
        model.averagePoints = data.average_points;
        model.highestPoints = data.highest_points;

        return model;
    };
}